import { render, staticRenderFns } from "./father_current_info.vue?vue&type=template&id=452a2777&scoped=true"
import script from "./father_current_info.vue?vue&type=script&lang=js"
export * from "./father_current_info.vue?vue&type=script&lang=js"
import style0 from "./father_current_info.vue?vue&type=style&index=0&id=452a2777&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452a2777",
  null
  
)

export default component.exports